import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type WorkOrderJobOpeningItem = ResultOf<
  typeof workOrderJobOpeningListQuery
>["workOrderJobOpenings"]["data"][number];

export const workOrderJobOpeningListQuery = graphql(`
  query WorkOrderJobOpeningList(
    $work_order_id: ID
    $page: Int
    $first: Int!
    $orderBy: [QueryWorkOrderJobOpeningsOrderByOrderByClause!]
  ) {
    workOrderJobOpenings(
      work_order_id: $work_order_id
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        id
        description
        depart_at
        deliver_at
        positions_available
        status
        offers_count
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
